export const APP_FILE_UTILITY = "/settings/utilities";
export const APP_FILE_MANAGE_UTILITY = "/settings/utilities/manage-utility";
